import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectOrderLiquidityCapsulesState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.ORDER_LIQUIDITY_CAPSULE];

export const selectOrderLiquidityCapsuleState = (
    state: State,
    widgetKey: string
) => selectOrderLiquidityCapsulesState(state)[widgetKey];
